import { render, staticRenderFns } from "./sicoob.vue?vue&type=template&id=1c8f8b3c&"
import script from "./sicoob.vue?vue&type=script&lang=js&"
export * from "./sicoob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports